import type { PixelRuntimeContext } from '@/runtime/PixelRuntimeContext';

export class VisitorEngine {
  private readonly context: PixelRuntimeContext;

  constructor(context: PixelRuntimeContext) {
    this.context = context;
  }

  init(): void {
    if (!this.context.config.modules.core.visitor.enabled) return;

    this.context.logger.debug('[VisitorEngine] Ensuring visitor');
    this.context.services.visitor.ensureVisitorId();
  }

  destroy(): void {}
}
